import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    right: {
        paddingLeft: "1rem",
    },
    start: {
        
    },
    element: {
        marginBottom: "1rem",
        marginTop: "1rem",

    },
    container: {
        marginLeft: 'auto',
        textAlign: 'center',
        marginRight: 'auto',
        marginTop: "2rem",
        width: "400px",
        maxWidth: "100%"
        // marginTop: '50%',
        // transform: 'translateY(-50%)',
    }
  }));
  const getCookieValue = (key) => {
      const value = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
      return value ? value.pop() : undefined;
  }

const Steps = ({policy, state, change}) => {
    const [value, setValue] = React.useState({email: state.email, zip: state.zip});

    React.useEffect(() => {
        const email = getCookieValue("email")
        const zip = getCookieValue("zip")
        if (email && zip && !state.email) {
            change({...state, email: email, zip: zip})
        }
    }, [])


    const login = () => {
        document.cookie = "email=" + value.email;
        document.cookie =  "zip=" + value.zip;
        change({...state, ...value})
        
        // eslint-disable-next-line no-undef
        // eslint-disable-next-line no-restricted-globals
        parent?.postMessage(
            {event: "Påbörja kalkyl"},
            "https://kalkyl.solelgrossisten.se"
        );
    }

    const classes = useStyles();
    return <Container>
        <Grid container spacing={3} className={classes.container}>
            <Grid item xs={12}>
                <Typography variant="h3" className={classes.element} >Välkommen</Typography>
                <Typography variant="subtitle1"  className={classes.element}>För att börja kalkylen behöver du skriva din e-mailadress &amp; ditt postnummer för att enkelt kunna hitta tillbaka till kalkylen igen.</Typography>

            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField value={value.email} onChange={event => setValue({...value, email: event.target.value})} fullWidth label="e-mail" className={classes.element}/>
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField value={value.zip} onChange={event => setValue({...value, zip: event.target.value})} fullWidth label="postnummer" className={classes.element}/>
            </Grid>
            <Grid item xs={12}>
                <Button color="primary" onClick={() => login()} fullWidth size="large" variant="outlined" className={classes.element}>Påbörja kalkyl</Button>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1"  className={classes.element}>All information du matar in sparas på servern och är tillgänglig även från en annan dator. Hur vi hanterar dina personuppgifter kan du läsa om <Link href={policy}>här</Link>.</Typography>
            </Grid>

        </Grid>
        </Container>

};

export default Steps;